<div [innerHTML]="profileExample.mainText" class="id37-text2 text-light"></div>
<h5 [innerHTML]="profileExample.graphicHeading" class="graphic-heading"></h5>
